module.exports = __webpack_public_path__ + "static/img/delete.274dbc88.svg";